'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$SignerLocation(latitude, longitude, accuracy) {
  this.Ff = 0.0;
  this.Fg = 0.0;
  this.Fe = 0.0;
  this.Ff = latitude;
  this.Fg = longitude;
  this.Fe = accuracy;
}
export { $c_Lpresto_types$proto$SignerLocation as $c_Lpresto_types$proto$SignerLocation };
$p = $c_Lpresto_types$proto$SignerLocation.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$SignerLocation;
/** @constructor */
function $h_Lpresto_types$proto$SignerLocation() {
}
export { $h_Lpresto_types$proto$SignerLocation as $h_Lpresto_types$proto$SignerLocation };
$h_Lpresto_types$proto$SignerLocation.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("SignerLocation"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().h7(this.Ff));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().h7(this.Fg));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().h7(this.Fe));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 3);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_types$proto$SignerLocation) && (((this.Ff === x$0.Ff) && (this.Fg === x$0.Fg)) && (this.Fe === x$0.Fe))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 3;
});
$p.s = (function() {
  return "SignerLocation";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.Ff;
      break;
    }
    case 1: {
      return this.Fg;
      break;
    }
    case 2: {
      return this.Fe;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_types$proto$SignerLocation(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lN)));
}
export { $isArrayOf_Lpresto_types$proto$SignerLocation as $isArrayOf_Lpresto_types$proto$SignerLocation };
var $d_Lpresto_types$proto$SignerLocation = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$SignerLocation, "presto.types$proto$SignerLocation", ({
  lN: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$SignerLocation as $d_Lpresto_types$proto$SignerLocation };
//# sourceMappingURL=presto.types$proto$-Signer-Location.js.map
